/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_ReadingInputs */



/**
* | output |
* | --- |
* | "Reading project file..." |
*
* @param {Load_Project_File_Status_ReadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_reading = /** @type {((inputs?: Load_Project_File_Status_ReadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_ReadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecture du fichier projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei wird gelesen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettura del file di progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чтение файла проекта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leyendo archivo de proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在读取项目文件...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト ファイルを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल पढ़ी जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lendo o arquivo do projeto...")
	return /** @type {LocalizedString} */ ("Reading project file...")
});